import React, { Component } from 'react';
import { connect } from 'react-redux';
import TypeHeadLeft from '../../../components/GREcomHeader/headers/CommonTypeHeadLeft/index';
import NewTypeHeadLeft from '../../../components/GREcomHeader/headers/NewCommonTypeHeadLeft/index';
import serverClientUtil from '../../../utils/serverClientUtil';
import commonUtil from '../../../utils/commonUtil';
import * as BrowseAndNevigateSearchAction from '../../../pages/BrowseAndNavigate/BrowseAndNevigateSearch/actions';
import * as NewBrowseAndNevigateSearchAction from '../../../pages/BrowseAndNavigate/NewBrowseAndNevigateSearch/actions';

@connect(store => ({
  SearchedPoductData: store.NewSearchedPoductData.data,
  globalObject: store.globleObject,
}),
  { ...BrowseAndNevigateSearchAction, ...NewBrowseAndNevigateSearchAction })

class SearchBar extends Component {
  constructor() {
    super();
    this.state = {
      inputSearch: '',
      toogleHideTypeAHead: false,
    };
    this.searchProduct = this.searchProduct.bind(this);
  }

  handOnKeyUp = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      window.open(serverClientUtil.getLPFullURL() + '?s=' + e.target.value, '_self');
    }
  }

  searchProduct = () => {
    const enteredData = document.querySelector('#search').value;
    if (enteredData.length !== 0) {
      let { SearchedDetailOfPoduct, BFFSearchedDetailOfPoduct } = this.props;
      SearchedDetailOfPoduct = BFFSearchedDetailOfPoduct;
      this.setState({ inputSearch: enteredData });
      SearchedDetailOfPoduct(enteredData, {}).then((res) => {
        if (res.status.status === 'success') {
          this.setState({ toogleHideTypeAHead: true });
        }
      });
    } else {
      this.setState({ toogleHideTypeAHead: false });
      this.setState({ inputSearch: '' });
    }
  }

  toogleHideTypeAHead = () => {
    this.setState({ toogleHideTypeAHead: false });
    this.setState({ inputSearch: '' });
  }

  render() {
    const { SearchedPoductData } = this.props;
    const currentColor = commonUtil.getCurrentBrandColors();
    const channel = commonUtil.getChannel();
    const getStylesDivSearch = () => {
      if (channel === 'wap') { return { maxWidth: '90%', flexGrow: '1' }; } return { maxWidth: '85%' };
    };
    const getStylesIconClose = () => ({
      position: 'absolute',
      top: channel === 'wap' ? '115px' : '0',
      right: channel === 'wap' ? '20px' : '0',
      color: '#A1A1A1',
      fontSize: '14px',
      padding: channel === 'wap' ? '10px 8px' : '14px 8px',
      cursor: 'pointer',
      display: this.state.toogleHideTypeAHead ? 'block' : 'none',
    });
    const getStylesTypeAhead = () => {
      if (!this.state.toogleHideTypeAHead) return { display: 'none' };
      return { display: 'block', background: '#FFFFFF' };
    };
    return (
      <React.Fragment>
        <div
          className="m-nav-search_input"
          style={getStylesDivSearch()}
        >
          <form className="nav-form" style={channel === 'wap' ? { paddingBottom: '16px' } : {}}>
            <input
              id="search"
              autoComplete="off"
              type="text"
              placeholder="Buscar por producto, categoría y más..."
              value={this.state.inputSearch}
              onChange={this.searchProduct}
              onKeyUp={(e) => { this.handOnKeyUp(e); }}
            />
            <span className="icon-tache2" style={getStylesIconClose()} onClick={this.toogleHideTypeAHead} />
            <div id="typeahead" style={getStylesTypeAhead()}>
              {SearchedPoductData && SearchedPoductData.suggestion ?
                <div className="m-typeAhead">
                  <NewTypeHeadLeft
                    inputSearch={this.state.inputSearch}
                    color={currentColor.primary}
                    {...this.props}
                  />
                  <div className="m-typeAhead__right" style={channel === 'wap' ? { display: 'none' } : {}}>
                    <p className="a-typeAhead__title">Lo más buscado</p>
                    <div className="m-typeAhead__results">
                      <React.Fragment>
                        {SearchedPoductData && SearchedPoductData.suggestion && SearchedPoductData.suggestion.products ?
                          SearchedPoductData.suggestion.products.map(data => (
                            <div className="m-typeAhead__resultCard">
                              <a href={serverClientUtil.getLPURL() + data.url}>
                                <figure className="m-resultCard__figure">
                                  {data && data.imgUrl && data.imgUrl !== null && data.imgUrl !== 'null' && data.imgUrl !== undefined && data.imgUrl !== 'undefined' ?
                                    <img id={'ahead_' + data.productId} alt={data.productName} src={data.imgUrl} />
                                    :
                                    <img id={'ahead_defaultImage'} alt={'ahead_defaultImage'} src={commonUtil.getAssetURL() + '/images/filler_REC.gif'} />
                                  }
                                  <figcaption className="a-resultCard__title">
                                    <p className="a-resultCard__title">{data.productName}</p>
                                  </figcaption>
                                </figure>
                              </a>
                            </div>
                          ))
                          :
                          null
                        }
                      </React.Fragment>
                    </div>
                  </div>
                </div>
                :
                null}
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}


export default SearchBar;
